import { render } from "./MovieGallery.vue?vue&type=template&id=7a65a607&scoped=true"
import script from "./MovieGallery.vue?vue&type=script&lang=js"
export * from "./MovieGallery.vue?vue&type=script&lang=js"

import "./MovieGallery.vue?vue&type=style&index=0&id=7a65a607&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a65a607"]])

export default __exports__